/* The mega menu's behaviour.

   Everything here exists to solve one of three problems.

   1. Flicker. Sweeping the pointer across the nav bar on the way to somewhere
      else should not fire four panels. So a heading has to be dwelt on for a
      moment before it opens — but only when nothing is open yet. Once a panel
      IS open, moving to the next heading switches instantly, because by then
      the buyer is clearly browsing the menu.

   2. The diagonal. The panel sits below the heading and is wider than it, so
      the natural path from heading to a card crosses dead space. Closing on
      mouseleave loses the menu mid-travel and is the single most common way a
      mega menu feels broken. So closing is delayed, and any re-entry cancels it.

   3. Touch and keyboard. On a touch screen there is no hover: the first tap on
      a heading opens the panel, the second follows the link. From the keyboard
      the heading is a real control — Enter or Space opens it, Escape closes it
      and hands focus back, and the arrow keys walk the category rail.

   There is a fourth, which is the grey box. The stand photographs are tiles of
   the sprite sheets the collection grid uses, and those are 2880px wide — four
   times more image than a 250px menu card can show. Opening a panel cold meant
   waiting on half a megabyte before anything appeared. So the first time a
   panel is approached, while it is still display:none and has therefore fetched
   nothing, every tile's sheet URL is rewritten to the CDN's half-size copy and
   the ones about to be shown are put in flight. The rewrite is a rename the
   Shopify CDN understands; no second set of images is kept.
*/
(function () {
  'use strict';
  var OPEN_DELAY = 130;   /* dwell before the first panel opens */
  var CLOSE_DELAY = 260;  /* grace to cross from heading to panel */

  var nav = document.querySelector('[data-mega-nav]');
  if (!nav) return;

  var groups = Array.prototype.slice.call(nav.querySelectorAll('[data-mega]'));
  if (!groups.length) return;

  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var coarse = window.matchMedia('(pointer: coarse)');
  var openTimer = null, closeTimer = null, current = null;

  function panelOf(g) { return g.querySelector('[data-mega-panel]'); }
  function topOf(g)   { return g.querySelector('[data-mega-top]'); }

  /* Point every tile at the half-size sheet, then start the ones the first
     pane will show. Runs once per panel, and only while it is still hidden —
     a background image on a display:none box is never fetched, so nothing has
     been downloaded at full size by the time this runs. */
  function warm(panel) {
    if (panel.dataset.warm) return;
    panel.dataset.warm = '1';
    var first = panel.querySelector('[data-mega-pane]');
    var queue = [];
    Array.prototype.forEach.call(panel.querySelectorAll('.pic'), function (el) {
      var bg = window.getComputedStyle(el).backgroundImage;
      if (!bg || bg.indexOf('mp-shot-') < 0) return;
      var small = bg.replace('.webp', '_1440x.webp');
      el.style.backgroundImage = small;
      if (first && first.contains(el)) {
        var u = small.split('url(')[1];
        if (u) {
          u = u.split(')')[0].split('"').join('').split("'").join('');
          if (queue.indexOf(u) < 0) queue.push(u);
        }
      }
    });
    queue.forEach(function (u) { var i = new Image(); i.src = u; });
  }

  function show(g) {
    clearTimeout(closeTimer);
    if (current && current !== g) hide(current, true);
    var p = panelOf(g), t = topOf(g);
    if (!p) return;
    p.hidden = false;
    /* hidden is removed first so the transition has something to run on */
    requestAnimationFrame(function () { p.setAttribute('data-open', 'true'); });
    if (t) t.setAttribute('aria-expanded', 'true');
    g.classList.add('mega-open');
    current = g;
  }

  function hide(g, immediate) {
    var p = panelOf(g), t = topOf(g);
    if (!p) return;
    p.removeAttribute('data-open');
    if (t) t.setAttribute('aria-expanded', 'false');
    g.classList.remove('mega-open');
    if (current === g) current = null;
    var done = function () { p.hidden = true; };
    if (immediate || calm.matches) done(); else setTimeout(done, 190);
  }

  function hideAll() {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    groups.forEach(function (g) { hide(g, true); });
  }

  groups.forEach(function (g) {
    var top = topOf(g), panel = panelOf(g);
    if (!top || !panel) return;

    top.setAttribute('aria-expanded', 'false');
    top.setAttribute('aria-haspopup', 'true');

    /* ---- pointer ---- */
    g.addEventListener('mouseenter', function () {
      warm(panel);              /* before the dwell, so the sheets get a start */
      if (coarse.matches) return;
      clearTimeout(closeTimer); clearTimeout(openTimer);
      if (current) { show(g); return; }          /* already browsing: no dwell */
      openTimer = setTimeout(function () { show(g); }, OPEN_DELAY);
    });
    g.addEventListener('mouseleave', function () {
      if (coarse.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { hide(g); }, CLOSE_DELAY);
    });

    /* ---- touch: first tap opens, second tap follows the link ---- */
    top.addEventListener('click', function (e) {
      if (!coarse.matches) return;
      if (current !== g) { e.preventDefault(); warm(panel); show(g); }
    });

    /* ---- keyboard ---- */
    top.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        warm(panel);
        show(g);
        /* The panel is visibility:hidden until data-open lands, and you cannot
           focus something that is not visible — so the rail is only reached on
           the frame after the one show() paints. */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            /* A heading with no children opens a panel with no rail, so
               there is nothing to walk — the first card is the thing to land
               on instead. */
            var first = panel.querySelector('[data-mega-cat]') ||
                        panel.querySelector('.mps-megacard');
            if (first) first.focus();
          });
        });
      }
    });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hideAll(); if (top) top.focus(); }
    });
    g.addEventListener('focusout', function () {
      /* only close once focus has genuinely left the group */
      setTimeout(function () {
        if (!g.contains(document.activeElement)) hide(g, true);
      }, 0);
    });

    /* ---- the rail drives the panes ---- */
    var cats  = Array.prototype.slice.call(panel.querySelectorAll('[data-mega-cat]'));
    var panes = Array.prototype.slice.call(panel.querySelectorAll('[data-mega-pane]'));

    function select(i) {
      cats.forEach(function (c, n) {
        c.classList.toggle('on', n === i);
        c.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      panes.forEach(function (p, n) { p.classList.toggle('on', n === i); });
    }

    cats.forEach(function (c, i) {
      /* hovering the rail swaps the pane; the link still works when clicked */
      c.addEventListener('mouseenter', function () { select(i); });
      c.addEventListener('focus', function () { select(i); });
      c.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown') n = (i + 1) % cats.length;
        if (e.key === 'ArrowUp')   n = (i - 1 + cats.length) % cats.length;
        if (n === null) return;
        e.preventDefault();
        cats[n].focus();
      });
    });
  });

  /* clicking away, or scrolling the page, closes it */
  document.addEventListener('click', function (e) {
    if (current && !current.contains(e.target)) hideAll();
  });
  window.addEventListener('scroll', function () { if (current) hideAll(); }, { passive: true });
})();